// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useEndorsementsPostType = () => {
  const { endorsements } = useStaticQuery(graphql`
    query Endorsements {
      endorsements: allWpEndorsement {
        nodes {
          id
          title
          menuOrder
          endorsements {
            age
            descriptor
            quote
          }
          locations: endorsementLocations {
            nodes {
              name
              slug
            }
          }
        }
      }
    }
  `);

  // TO-DO: Fix reordering plugin
  // menuOrder 0 currently comes through to GQL as null and therefore the first post comes through as last without this additional logic
  const nodes = endorsements?.nodes;

  const newNodes = nodes.filter((node) => node?.menuOrder !== null);

  const nullOrder = nodes.filter((node) => node?.menuOrder == null);

  if (nullOrder.length) newNodes.unshift(nullOrder.pop());

  return newNodes;
};

export default useEndorsementsPostType;
